import { computed, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ProjectGetter } from '@/store/project/project.module';
import { Project } from '@/store/project/project.model';
import { EnjoinGetter } from '@/store/enjoin/enjoin.module';
import { Enjoin } from '@/store/enjoin/enjoin.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectCommentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    projectId: {
      type: Number,
    },
  },
  setup: (props) => {
    const router = useRouter();
    const store = useStore();
    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const enjoins = computed<Enjoin[]>(() => store.getters[EnjoinGetter.ALL]);
    const commentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();
    const enjoinId = ref<number | null>();

    // show modal
    const show = () => {
      enjoinId.value = null;
      commentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      commentOffcanvas.value?.hide();
    };

    // enjoin click
    const enjoinClick = (id: number) => {
      enjoinId.value = id;
      hide();
    };

    // enjoin redirect
    const enjoinRedirect = () => {
      if (enjoinId.value) {
        router.push(`/enjoin/${enjoinId.value}`);
      }
    };

    return {
      project,
      enjoins,
      commentOffcanvas,
      show,
      hide,
      enjoinClick,
      enjoinRedirect,
    };
  }
});
